export const TOP_MODEL = 'top_model'
export const MODEL_RANK_CHANGE = 'model_rank_change'
export const MODEL_AVAILABILITY = 'model_availability'
export const NEW_MODEL = 'new_model'
export const NEW_EVALUATION = 'new_evaluation'
export const MODEL_CHANGE = 'model_change'
export const SCORE_THRESHOLD = 'score_threshold'

export const EMAIL = 'email'
export const WEBHOOK = 'webhook'
export const TEXT_MESSAGE = 'sms'
export const PHONE_CALL = 'call'

export const FREE_RESPONSE_QUESTION = 'FRQ'
export const MULTIPLE_CHOICE_QUESTION = 'MCQ'
export const BOOLEAN_QUESTION = 'bool'
export const JSON_QUESTION = 'json'

export const REDACTED_COLUMN = 'redacted'
export const TYPE_COLUMN = 'type'
export const QUESTION_COLUMN = 'question'
export const BOOL_CORRECT_COLUMN = 'bool_correct'
export const MCQ_CORRECT_COLUMN = 'mcq_correct'
export const MCQ_INCORRECT_COLUMN = 'mcq_incorrect'
export const FRQ_CORRECT_COLUMN = 'frq_correct'
export const FRQ_INCORRECT_COLUMN = 'frq_incorrect'
export const PARAPHRASE = 'paraphrase'
export const JSON_SCHEMA = 'json_schema'
export const JSON_EXPECTED = 'json_expected'
